import { applyMiddleware, configureStore, combineReducers } from '@reduxjs/toolkit';
import { History } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { StateShape, reducers } from './reducers';

export default function configureStoreX(
    history: History,
    basename: string | undefined,
    initialState: Partial<StateShape> | undefined
) {
    const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
        history,
        basename,
    });

    const middleware = [routerMiddleware];
    let devTools = false;

    if (process.env.NODE_ENV === 'development') {
        devTools = true;
        const { logger } = require('redux-logger');
        middleware.push(logger);
    }

    const enhance = applyMiddleware(...middleware);

    const rootReducer = combineReducers({
        ...reducers,
        router: routerReducer,
    });

    const store = configureStore({
        reducer: rootReducer,
        enhancers: [enhance],
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }),
        preloadedState: initialState,
        devTools,
    });

    const storeHistory = createReduxHistory(store);

    return {
        store,
        history: storeHistory,
    };
}
